import React, { useState } from "react";
import { Typography, Button, Row, Col, message } from "antd";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { verifyOtp } from "../../../redux/action/auth/authAction";
import OtpInputBox from "./OtpInputBox";
import LogoImg from "../../../assets/images/smallLogo.svg";
import BannerImg from "../../../assets/images/banner.png";
import BackArrowImg from "../../../assets/images/arrowLeft.png";

const { Title, Text } = Typography;

const VerifyOtp = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [otp, setOtp] = useState("");

  const handleVerifyOtp = async () => {
    if (otp.length !== 6) {
      message.error("Please fill all the boxes with 6 digits.");
      return;
    }
    try {
      dispatch(
        verifyOtp({ otp }, () => {
          message.success("OTP Verified Successfully");
          navigate("/reset-password");
        })
      );
    } catch (error) {
      message.error("OTP verification failed. Please try again.");
    }
  };

  return (
    <div className="signinContainer">
      <Row gutter={16} className="signinRow">
        <Col xs={24} sm={12}>
          <div className="leftSection cflex">
            <div className="leftContainer">
              <img
                src={LogoImg}
                alt="Logo"
                className="logo"
                height={200}
                width={200}
              />
              <div className="viewTenant">
                <div
                  className="backToLogin mt-3"
                  onClick={() => navigate(-1)}
                  style={{ cursor: "pointer" }}
                >
                  <img src={BackArrowImg} alt="BackArrowImg" />
                  Back To Login
                </div>
              </div>
              <Title level={2}>Verify OTP</Title>
              <Text className="subtitle mb-2">
                We have sent a verification code to your provided email address.
                Please enter the code below.
              </Text>
              <form className="signin-form">
                <div className="otpBx">
                  <OtpInputBox otp={otp} setOtp={setOtp} />
                </div>

                <Button
                  type="primary"
                  className="customButton mt-3"
                  onClick={handleVerifyOtp}
                >
                  Verify
                </Button>
                <Text className="subtitle mt-5 text-center">
                  © Cultiva 2025
                </Text>
              </form>
            </div>
          </div>
        </Col>

        <Col xs={24} sm={12}>
          <div className="rightSection cflex">
            <img src={BannerImg} alt="Banner" className="banner" />
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default VerifyOtp;
